import cn from 'classnames'
import { FC, useEffect } from 'react'

import { Button } from 'core-components/library/button'
import { Skeleton } from 'shared/components/skeleton'

import { IAssortmentTabProviderProps } from '../../models/IAssortmentTabProviderProps'
import { ApplicableChangeConfirmDialog } from '../applicableChangeConfirmDialog/ApplicableChangeConfirmDialog'

import { AssortmentCategory } from './components/assortmentCategory/AssortmentCategory'
import { useAssortmentSideBar } from './hooks/useAssortmentSideBar'

import styles from './AssortmentSidePanel.module.scss'

export const AssortmentSidePanel: FC<IAssortmentTabProviderProps> = ({
  partnerId,
  programType,
  fYear,
}) => {
  const {
    isLoading,
    selectedCategory,
    categories,
    getAssortmentItems,
    setSelectedCategory,
    toggleAssortmentSideBar,
    isCollapsed,
  } = useAssortmentSideBar({
    partnerId,
    programType,
    fYear,
  })

  useEffect(() => {
    getAssortmentItems()
  }, [getAssortmentItems])

  if (isLoading) {
    return <Skeleton className={styles.skeletonLoader} />
  }

  return (
    <div
      className={cn(styles.root, {
        [styles.collapsed]: isCollapsed,
      })}
    >
      <div className={styles.content}>
        {categories.map((it) => (
          <AssortmentCategory
            key={it.EntryId}
            isCollapsed={isCollapsed}
            isSelected={it.EntryId === selectedCategory?.EntryId}
            partnerId={partnerId}
            fYear={fYear}
            item={it}
            onClick={setSelectedCategory}
          />
        ))}
      </div>
      <div className={styles.controls}>
        <Button
          className={styles.icon}
          iconButton={cn({
            'kbase kbase-omni-arrows-right': isCollapsed,
            'kbase kbase-omni-arrows-left': !isCollapsed,
          })}
          onClick={toggleAssortmentSideBar}
        />
      </div>
      <ApplicableChangeConfirmDialog />
    </div>
  )
}
